<template>
  <div class="accesibilidad">


 <!-- <div style="position:relative;"> -->
      <button class="posicionamiento" @click="menu_close = !menu_close ">
        <i class="fas fa-wheelchair"></i>
      </button>
    <div id="accesibilidad_slide" class="sidenav" style="width:182px !important;" v-if="menu_close">


        <a @click="menu_close = false" class="d-flex justify-content-between align-items-center closebtn py-0 px-3 m-0 bg-light w-100" style="margin-right:-1rem;">
            <span class="m-0 p-0" style="font-size:1rem;">Accesibilidad</span> &times;
        </a>

        <div>
            <div class="">
              <button class="btn-transparent" @click="EscalaGris(!gris)"> <i style="color: rgb(87, 87, 87);" class="fas fa-adjust"></i> Escala a grises </button>
              <button class="btn-transparent" @click="fontSize()"> <i class="fas fa-text-height"></i> Tamaño de texto </button>
              <button class="btn-transparent" @click="AltoContraste(!menu)"> <i class="fas fa-adjust"></i> Contraste </button>
              <button class="btn-transparent" @click="letra_legible(!legible)"> <i class="fas fa-font"></i> Letra legible </button>
              <button class="btn-transparent" @click="reset_accesibilidad(true)"> <i class="fas fa-sync-alt"></i> Reset estilos </button>
            </div>
        </div>
    </div>
<!-- </div> -->


    <!--  -->

  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex'

export default ({
  nam: 'componenteAccesibilidad',
  data: function() {
    return{
      gris: false,
      numero: 0,
      menu: false,
      legible: false,
      menu_close: false
    }
  },
  computed:{ ...mapState(['modoDark_var']) },
  methods:{
    ...mapMutations(['modoDark']),
    EscalaGris(booleano){
      if(booleano && this.modoDark_var) this.modoDark();
      this.reset_accesibilidad(false);

      this.gris = booleano;

      let escalagris = document.getElementById('escalaGrisesFuncion'),
          escalagris_ = document.getElementById('escalaGrisesFuncion_');

      if(this.gris){
        escalagris.className = 'filtoGris';
        escalagris_.className = 'filtoGris'
      }
      else{
        escalagris.className = 'filtoColor';
        escalagris_.className = 'filtoColor';
      }

    },
    fontSize(){
      if(this.numero<4) this.numero += 1;
      else this.numero = 0;
        let p = document.getElementsByTagName("p"),
            a = document.getElementsByTagName("a"),
            h1 = document.getElementsByTagName("h1"),
            h2 = document.getElementsByTagName("h2"),
            h3 = document.getElementsByTagName("h3"),
            h4 = document.getElementsByTagName("h4"),
            h5 = document.getElementsByTagName("h5"),
            h6 = document.getElementsByTagName("h6"),

            h6_servicios = document.getElementsByClassName("h6_servicios"),


            element = document.getElementsByClassName("element"),
            description = document.getElementsByClassName("description"),
            img = document.getElementsByClassName("img"),

            anchoNav = document.getElementById("anchoNav"),
            logoHacienda_div = document.getElementById("logoHacienda_div"),

            logoHacienda = document.getElementById("logoHacienda"),
            nav_item = document.getElementsByClassName("nav-link");

            console.log(element);


          for (let i = 0; i < element.length; i++) {
            if(this.numero > 0) element[i].classList.add('element_');
            if(this.numero == 0) element[i].classList.remove('element_');
          }
          for (let i = 0; i < description.length; i++) {
            if(this.numero > 0) description[i].classList.add('description_');
            if(this.numero == 0) description[i].classList.remove('description_');
          }
          for (let i = 0; i < img.length; i++) {
            if(this.numero > 0) img[i].classList.add('img_');
            if(this.numero == 0) img[i].classList.remove('img_');
          }

          /*--------------------------------------------------------*/

        for (let i = 0; i < p.length; i++) {
          if(this.numero > 0) p[i].classList.remove('font'+(this.numero-1));
          if(this.numero == 0) p[i].classList.remove('font4');
          p[i].classList.add('font'+this.numero);
        }
        for (let i = 0; i < a.length; i++) {
          if(this.numero > 0) a[i].classList.remove('font'+(this.numero-1));
          if(this.numero == 0) a[i].classList.remove('font4');
          a[i].classList.add('font'+this.numero);
        }
        for (let i = 0; i < h5.length; i++) {
          if(this.numero > 0) h5[i].classList.remove('h1Font'+(this.numero-1));
          if(this.numero == 0) h5[i].classList.remove('h1Font4');
          h5[i].classList.add('h1Font'+this.numero);
        }
        for (let i = 0; i < h1.length; i++) {
          if(this.numero > 0) h1[i].classList.remove('h1Font'+(this.numero-1));
          if(this.numero == 0) h1[i].classList.remove('h1Font4');
          h1[i].classList.add('h1Font'+this.numero);
        }
        for (let i = 0; i < h4.length; i++) {
          if(this.numero > 0) h4[i].classList.remove('h1Font'+(this.numero-1));
          if(this.numero == 0) h4[i].classList.remove('h1Font4');
          h4[i].classList.add('h1Font'+this.numero);
        }
        for (let i = 0; i < h6.length; i++) {
          if(this.numero > 0) h6[i].classList.remove('h1Font'+(this.numero-1));
          if(this.numero == 0) h6[i].classList.remove('h1Font4');
          h6[i].classList.add('h1Font'+this.numero);
        }
        for (let i = 0; i < h3.length; i++) {
          if(this.numero > 0) h3[i].classList.remove('h1Font'+(this.numero-1));
          if(this.numero == 0) h3[i].classList.remove('h1Font4');
          h3[i].classList.add('h1Font'+this.numero);
        }
        for (let i = 0; i < h2.length; i++) {
          if(this.numero > 0) h2[i].classList.remove('h1Font'+(this.numero-1));
          if(this.numero == 0) h2[i].classList.remove('h1Font4');
          h2[i].classList.add('h1Font'+this.numero);
        }
        /* ciclo para las cards de servicios del home */
        for (let i = 0; i < h6_servicios.length; i++) {
          if(this.numero > 0) {
            h6_servicios[i].classList.remove('h1Font'+(this.numero-1));
            h6_servicios[i].classList.remove('h6Font'+(this.numero-1));
            h6_servicios[i].classList.remove('small');
          }
          if(this.numero == 0) {
            h6_servicios[i].classList.remove('h1Font4');
            h6_servicios[i].classList.remove('h6Font4');
            h6_servicios[i].classList.add('small');
          }
          h6_servicios[i].classList.add('h6Font'+this.numero);
        }

        /* cambio en el logo del navbar "secretaria de hacienda" */
        if(this.numero > 0){
          logoHacienda.classList.remove('font1');
          logoHacienda.classList.add('logoHacienda');
          anchoNav.classList.remove('container');
          anchoNav.classList.add('anchoNav');
          logoHacienda_div.classList.add('logoHacienda_div');

          for (let i = 0; i < nav_item.length; i++) {
            nav_item[i].classList.remove('font'+(this.numero-1));
            nav_item[i].classList.add('opcionesNav');
          }
        }else{
          logoHacienda.classList.add('font1');
          logoHacienda.classList.remove('logoHacienda');
          anchoNav.classList.remove('anchoNav');
          anchoNav.classList.add('container');
          logoHacienda_div.classList.remove('logoHacienda_div');

          for (let i = 0; i < nav_item.length; i++) nav_item[i].classList.remove('opcionesNav');

        }

        // console.log(this.numero);

    },
    AltoContraste(booleano){
      this.EscalaGris(false);
      this.menu = booleano;
      let navbar = document.getElementById("navbarPrincipal"),
      p = document.getElementsByTagName("p"),
      contrasteFondo = document.getElementById("contenedor_cards"),
      contrasteFondo2 = document.getElementById("contrasteFondo2"),
      escalagris = document.getElementById('escalaGrisesFuncion'),
      sala_prensa = document.getElementById("sala_prensa"),
      // titulares = document.getElementsByClassName("nav-link"),
      social_section = document.getElementById("social_section"),
      prensaTitulo = document.getElementById("prensaTitulo"),
      prensaTitulo1 = document.getElementById("prensaTitulo1"),
      socialTitulo = document.getElementById("socialTitulo"),
      letrasMenu = document.getElementsByClassName('opciones_menu'),
      socialTitulo1 = document.getElementById("socialTitulo1");

      // console.log('contrasteFondo ', contrasteFondo );

      if(this.menu){
        navbar.style.backgroundColor="black";
        escalagris.classList.add('modoDark');
      } else{
        navbar.removeAttribute('style');
        escalagris.classList.remove('modoDark');
      }

      let classname = document.getElementsByClassName('nav-link');
      // console.log(classname[0]);
      for (let i = 0; i < classname.length; i++) classname[i].style.color="#fff";

      if(this.menu){
          if(contrasteFondo != null){
              contrasteFondo.id = 'contrasteFondo2';
              contrasteFondo.classList.add('contrasteFondo');
          }
          if(sala_prensa != null){
              sala_prensa.classList.add('contrasteFondo');
              sala_prensa.classList.remove('bg-color-light');

              prensaTitulo.classList.remove('color-vino1');
              prensaTitulo.style.color="#fff";
              prensaTitulo1.classList.remove('color-vino1');
              prensaTitulo1.style.color="#fff";
          }
          if(social_section != null){
            social_section.style.backgroundColor="black";
            socialTitulo.classList.remove('color-negro1');
            socialTitulo.style.color="#fff";
            socialTitulo1.classList.remove('color-negro1');
            socialTitulo1.style.color="#fff";
          }

        for (let i = 0; i < letrasMenu.length; i++) letrasMenu[i].classList.add('contrasteA')

      }
      else{
          if(contrasteFondo2 != null){
              contrasteFondo2.id = 'contenedor_cards';
              contrasteFondo2.classList.remove('contrasteFondo');
          }
          if(sala_prensa != null){
              sala_prensa.classList.remove('contrasteFondo');
              sala_prensa.classList.add('bg-color-light');

              prensaTitulo.removeAttribute('style');
              prensaTitulo.classList.add('color-vino1');
              prensaTitulo1.removeAttribute('style');
              prensaTitulo1.classList.add('color-vino1');
          }
          if(social_section != null){
            social_section.style.backgroundColor="#fff";
            socialTitulo.classList.add('color-negro1');
            socialTitulo.removeAttribute('style');
            socialTitulo1.classList.add('color-negro1');
            socialTitulo1.removeAttribute('style');
          }

        for (let i = 0; i < letrasMenu.length; i++) letrasMenu[i].classList.remove('contrasteA')
      }

      for (let i = 0; i < p.length; i++) {
          if(this.numero > 0) p[i].classList.remove('font'+(this.numero-1));
          if(this.numero == 0) p[i].classList.remove('font4');
          p[i].classList.add('font'+this.numero);
        }

        this.modoDark();
    },
    reset_accesibilidad(tipo_accion){ //tipo_accion = evita q se forme un ciclo infinito, bandera q mide si viene desde otra funcion o del boton de reset
      let logoHacienda_div = document.getElementById("logoHacienda_div"),
          navbar = document.getElementById("navbarPrincipal"),
          p = document.getElementsByTagName("p"),
          logoHacienda = document.getElementById("logoHacienda"),
          anchoNav = document.getElementById("anchoNav"),
          nav_item = document.getElementsByClassName("nav-link"),
          social_section = document.getElementById("social_section"),
          sala_prensa = document.getElementById("sala_prensa"),
          prensaTitulo = document.getElementById("prensaTitulo"),
          prensaTitulo1 = document.getElementById("prensaTitulo1"),
          element = document.getElementsByClassName("element"),
          description = document.getElementsByClassName("description"),
          img = document.getElementsByClassName("img"),
          h6_servicios = document.getElementsByClassName("h6_servicios"),
          body = document.getElementById("escalaGrisesFuncion"),
          a = document.getElementsByTagName("a"),
          h1 = document.getElementsByTagName("h1"),
          h2 = document.getElementsByTagName("h2"),
          h3 = document.getElementsByTagName("h3"),
          h4 = document.getElementsByTagName("h4"),
          h5 = document.getElementsByTagName("h5"),
          h6 = document.getElementsByTagName("h6");

      logoHacienda.classList.remove('logoHacienda');
      anchoNav.classList.remove('anchoNav');
      anchoNav.classList.add('container');
      logoHacienda_div.classList.remove('logoHacienda_div');
      navbar.removeAttribute('style');

      for (let i = 0; i < nav_item.length; i++) nav_item[i].classList.remove('opcionesNav');
      for (let i = 0; i < p.length; i++) p[i].classList.remove('font'+this.numero);
      for (let i = 0; i < a.length; i++) a[i].classList.remove('font'+this.numero);
      for (let i = 0; i < h1.length; i++) h1[i].classList.remove('h1Font'+(this.numero));
      for (let i = 0; i < h5.length; i++) h5[i].classList.remove('h1Font'+this.numero);
      for (let i = 0; i < h6.length; i++) h6[i].classList.remove('h1Font'+this.numero);

      for (let i = 0; i < h2.length; i++) h2[i].classList.remove('h1Font'+this.numero);
      for (let i = 0; i < h3.length; i++) h3[i].classList.remove('h1Font'+this.numero);
      for (let i = 0; i < h4.length; i++) h4[i].classList.remove('h1Font'+this.numero);



      for (let i = 0; i < element.length; i++) element[i].classList.remove('element_');
      for (let i = 0; i < description.length; i++) description[i].classList.remove('description_');
      for (let i = 0; i < img.length; i++) img[i].classList.remove('img_');
      for (let i = 0; i < h6_servicios.length; i++) {
        h6_servicios[i].classList.remove('h1Font4');
        h6_servicios[i].classList.remove('h6Font4');
        h6_servicios[i].classList.add('small');
      }


      /* desactivo contraste en cardsPersianas y salaPrensa */
      if(this.menu){

        if(tipo_accion) this.AltoContraste(false);

        if(sala_prensa != null){
            sala_prensa.classList.remove('contrasteFondo');
            sala_prensa.classList.add('bg-color-light');
            prensaTitulo.removeAttribute('style');
            prensaTitulo.classList.add('color-vino1');
            prensaTitulo1.removeAttribute('style');
            prensaTitulo1.classList.add('color-vino1');
        }

        if(social_section != null){
            social_section.style.backgroundColor="#fff";
            socialTitulo.classList.add('color-negro1');
            socialTitulo.removeAttribute('style');
            socialTitulo1.classList.add('color-negro1');
            socialTitulo1.removeAttribute('style');
        }



      }
      if(this.legible) body.classList.remove('body_');
      // if(this.gris){
        // escalagris.className = 'filtoColor';
        // escalagris_.className = 'filtoColor';
        if(tipo_accion) this.EscalaGris(false);
        // }


      // this.AltoContraste(false);
      // this.EscalaGris(false);
      // this.letra_legible(false);

      this.numero = 0;
      this.menu = false;
      this.legible = false;
      this.gris = false;
      this.menu_close = false;
    },
    letra_legible(booleano){
      this.legible = booleano;
      let body = document.getElementById("escalaGrisesFuncion");
      if(this.legible) body.classList.add('body_');
      else body.classList.remove('body_');
    }

  }
})
</script>
<style scoped>

i{ margin-right: .8rem; }
.btn-transparent{
  background: transparent;
  border: none;
  display:block;
  padding: .5rem .2rem;
}

  .accesibilidad{
    position: fixed;
    z-index: 10000;
    top: 13%;
}


    #formulario-login .container{
        max-width: 1000px !important;
        /* box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important; */
    }
    #formulario-login .img{width:25%;}
    label, .text-confirmacion{
        color: #777272 !important;
        margin-bottom: 0 !important;
    }
    #formulario-login .tramite{
        width: 30%;
        /* background-color: #f7f7f7; */
        display: flex !important;
        align-items: center !important;
        /* background-image: url(img.jpg); */
    }
    #formulario-login .login{
        padding: .5rem 2rem 2rem 2rem;

    }
    #formulario-login label{ font-size: .8rem; color: #b2afaf; }
    #formulario-login h5{
        font-size: 1.7rem;
        font-weight: 400;
        color: #625151;
    }
    #formulario-login  button { font-weight:500;}
    #formulario-login .txt-resetPass{
        font-size: 12.5px;
        margin-top: .5rem;
        font-weight: 500;
        /* color: #5897fb; */
    }
    /****** */
    .formulario-registro{
        /**max-width: 1000px !important;**/
        margin-top: 3rem;
        margin-bottom: 5rem;
        border: 2px solid #efefef;
        padding: 2rem 3rem 3rem 3rem;
        border-left: 5px solid #7f2535;
    }
    /* ________________ */





.sidenav {
  height: 42%;
  width: 0;
  position: fixed;
  z-index: 3000;
  top: 20%;
  left: 0;
  background-color: #fff;
  border: 1px solid  #b5b1b1c4;
  border-left:4px solid grey;
  overflow-x: hidden;
  transition: 0.5s;
  padding-top: 60px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 30px;
}

.sidenav a {
  padding: 1rem;
  text-decoration: none;
  font-size: 1.1rem;
  color: #686868;
  display: block;
  transition: 0.3s;
}

.sidenav a:hover {
  color: /*#f1f1f1;*/  #691c32;/* #9f2241;*/
}

.sidenav .closebtn {
  position: absolute;
  top: 0;
  font-size: 36px;
}



.posicionamiento{
  border-top-left-radius: 0px !important;
  background: #4054b2;
  color: white;
  padding: .8rem;
  border: none;
}

@media screen and (max-height: 450px) {
  .sidenav {padding-top: 15px;}
  .sidenav a {font-size: 18px;}
}

</style>
